import script from "./MoneyPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./MoneyPage.vue?vue&type=script&setup=true&lang=ts"

import "./MoneyPage.vue?vue&type=style&index=0&id=6fe303b8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6fe303b8"]])

export default __exports__